// extracted by mini-css-extract-plugin
module.exports = {"parallax":"home_parallax__2Vi_y","Card":"home_Card__1RazN","Header":"home_Header__5eZza"};